export const phoneMask = [
  '+',
  '5',
  '5',
  ' ',
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const phoneMaskParenthesis = [
  '+',
  '5',
  '5',
  ' ',
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const landlinePhoneMask = [
  '+',
  '5',
  '5',
  ' ',
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const phoneMaskWithParenthesis = [
  '+',
  '5',
  '5',
  ' ',
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const landlineMaskWithParenthesis = [
  '+',
  '5',
  '5',
  ' ',
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const cpfMask = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/
]

export const rgMask = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/
]

export const dateMask = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/
]

export const dateTimeMask = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  ':',
  /\d/,
  /\d/
]

export const temperatureMask = [/\d/, /\d/, '.', /\d/, ' °C']

export const ufMask: (string | RegExp)[] = [/^[A-Z]*$/, /^[A-Z]*$/]

export const zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]

export const nameMask = (name: string): (string | RegExp)[] => {
  return name.split('').map(() => /^[a-zA-Z\xC0-\uFFFF\s]+$/gi)
}

export const RgRegex = /^\d{0,10}(\d|x|X)$/i

export function formatMask(mask: (string | RegExp)[], value: string) {
  if (!value) return ''
  const chars = value.split('')

  let masked = ''

  for (let i = 0, k = 0; i < mask.length; i++) {
    const maskElement = mask[i]
    if (maskElement instanceof RegExp) {
      masked += maskElement.test(chars[k]) ? chars[k] : ''
      k++
    } else {
      masked += maskElement
    }
  }

  return masked
}

export function formatPhone(phone?: string) {
  return formatMask(phoneMask, phone ?? '')
}

export function formatTelephoneWithParenthesis(phoneNumber?: string) {
  if (!phoneNumber) return ''

  const cleanNumber = phoneNumber.replace(/\D/g, '')

  let number = cleanNumber

  if (cleanNumber.startsWith('55')) {
    number = cleanNumber.slice(2)
  }

  const ddd = number.slice(0, 2)
  const firstPart = number.slice(2, 7)
  const secondPart = number.slice(7, 11)

  return `+55 (${ddd}) ${firstPart}-${secondPart}`
}
